import React from "react";


import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";


import { Checkbox } from "rsuite";

export default ({
    filter,
    onChangeFilter
}) => {
    return (
        <>
            <FlexGrid align="middle">
                <FlexGridItem>
                    <Checkbox
                        name="processed"
                        onChange={(_, checked) => { onChangeFilter({ processed: checked }) }}
                        defaultChecked={filter.processed}
                    >
                        Show processed
                    </Checkbox>
                </FlexGridItem>
            </FlexGrid>
        </>
    );
};